package com.qrkontaq.core.auth

import com.qrkontaq.utils.Storage
import kotlinx.browser.window

/** Persisted auth session (localStorage). Cookie-on-parent-domain SSO comes later. */
object Session {
    private const val KEY_ACCESS = "auth.accessToken"
    private const val KEY_REFRESH = "auth.refreshToken"
    private const val KEY_ACTIVE_RESTAURANT = "admin.activeRestaurantId"

    var accessToken: String?
        get() = Storage.get(KEY_ACCESS)?.takeIf { it.isNotEmpty() }
        set(value) = Storage.save(KEY_ACCESS, value.orEmpty())

    var refreshToken: String?
        get() = Storage.get(KEY_REFRESH)?.takeIf { it.isNotEmpty() }
        set(value) = Storage.save(KEY_REFRESH, value.orEmpty())

    var activeRestaurantId: String?
        get() = Storage.get(KEY_ACTIVE_RESTAURANT)?.takeIf { it.isNotEmpty() }
        set(value) = Storage.save(KEY_ACTIVE_RESTAURANT, value.orEmpty())

    val isLoggedIn: Boolean get() = accessToken != null

    /** Current user id from the access token's `sub` claim (JWT), or null. */
    val userId: String?
        get() {
            val parts = accessToken?.split(".") ?: return null
            if (parts.size < 2) return null
            return runCatching {
                var b64 = parts[1].replace('-', '+').replace('_', '/')
                while (b64.length % 4 != 0) b64 += "="
                val payload = JSON.parse<dynamic>(window.atob(b64))
                (payload.sub as? String)?.takeIf { it.isNotEmpty() }
            }.getOrNull()
        }

    fun clear() {
        accessToken = null
        refreshToken = null
        activeRestaurantId = null
    }
}
